import React from 'react';

import { generateClient } from 'aws-amplify/api';

import { ChatMessageItem } from '../../../graphql/API';
import { onVenueReceiveChatMessageFromUser } from '../../../graphql/subscriptions';
import { GqlError, getError, getErrorFromResult, processGqlResult } from '../../../utils/gql-utils';

const client = generateClient();

export const useUserChatMessageListenerEvent = (fromUserId: string, toUserId: string) => {
  const [message, setMessage] = React.useState<Nullable<ChatMessageItem>>(null);
  const [error, setErorr] = React.useState<GqlError>();

  React.useEffect(() => {
    if (fromUserId && toUserId) {
      const createSub = client.graphql({
        query: onVenueReceiveChatMessageFromUser,
        variables: { userType: 'venue/user', toUserId, fromUserId },
      }).subscribe({
        next: ({ data }: { data: { onVenueReceiveChatMessageFromUser: ChatMessageItem } }) => {
          const _message = processGqlResult<ChatMessageItem>(
            'onVenueReceiveChatMessageFromUser',
            { data },
          );
          setMessage(_message);
          const errorFromResponse = getErrorFromResult({ data });

          if (errorFromResponse) {
            throw errorFromResponse;
          }
        },
        error: (ex) => {
          const raisedError = getError(ex);
          console.error(raisedError);
          setErorr(raisedError);
        },
      });

      return () => {
        createSub.unsubscribe();
      };
    }
  }, [fromUserId, setMessage, toUserId]);

  return {
    message,
    error,
  };
};
